import { useState, useEffect } from "react";
import axios from "axios";
import Card from "./Card";
import CardLoading from "./CardLoading";
import "./Card.css";

function CardContainer({ isClicked, limit }) {
  const [data,    setData]    = useState([]);
  const [loading, setLoading] = useState(true);
  const pageApiPath = process.env.REACT_APP_PAGES_API_PATH;
  const apiKey      = process.env.REACT_APP_API_KEY;

  useEffect(() => {
    axios
      .get(pageApiPath, {
        headers: { Authorization: `Api-Key ${apiKey}` },
        params: { type: "Case.CaseStudyPage", fields: "thumbnail,group,author,intro", order: "-first_published_at" },
      })
      .then((res) => setData(res.data.items))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [pageApiPath, apiKey]);

  const filtered = data.filter((d) => d.group?.includes(isClicked));
  const visible  = limit ? filtered.slice(0, limit) : filtered;
  const skeletonCount = limit ?? 8;

  if (loading) {
    return (
      <div className="card-grid">
        {Array.from({ length: skeletonCount }, (_, i) => <CardLoading key={i} />)}
      </div>
    );
  }

  if (!visible.length) {
    return (
      <div className="no-data">
        <p className="body-large" style={{ fontWeight: 600 }}>No projects found</p>
      </div>
    );
  }

  return (
    <div className="card-grid">
      {visible.map((d) => (
        <Card
          key={d.id}
          link={d.id}
          image={d.thumbnail?.url || ""}
          heading={d.title}
          description={d.intro}
        />
      ))}
    </div>
  );
}

export default CardContainer;
